/** Zgodne z `HOME_PRERENDER_CRITICAL_CSS` w `staticHtml.ts`. */
export const HOME_BOOT_SPLASH_MS = 2450
export const HOME_BOOT_FADE_MS = 400

/** Ukrywa splash po zakończeniu animacji (overlay nad #root). */
export function dismissHomeBootSplash(): void {
  const boot = document.getElementById('pds-boot')
  if (!boot) return

  const reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches
  const waitMs = reduced ? 0 : HOME_BOOT_SPLASH_MS

  const remove = () => boot.remove()

  if (waitMs <= 0) {
    remove()
    return
  }

  window.setTimeout(() => {
    boot.classList.add('pds-boot--leaving')
    boot.setAttribute('aria-busy', 'false')
    window.setTimeout(remove, HOME_BOOT_FADE_MS)
  }, waitMs)
}
